import Sidebar from "../../../components/sidebar/Sidebar"
import Navbar from "../../../components/navbar/Navbar"
import "../../Patient/list.scss"
import DiagnosisList from "./diagnosisList"

const DiagnosisListContainer = () => {

 
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <>
        <DiagnosisList  />
        </>
      </div>
    </div>
  )
}

export default DiagnosisListContainer